import PromotionsNotification from './PromotionsNotification.component';
export default PromotionsNotification;